import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=7cd2b232&"
import script from "./DetailModal.vue?vue&type=script&lang=js&"
export * from "./DetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports